import { environments } from '../../environments/env.production';

const baseURL = environments.baseUrl;
const webSocketURL = environments.ngRok;
const secondaryUrl = environments.secondaryUrl;

export const apiPath = {
  claims: {
    list: `${baseURL}Batch/claims`,
    detail: (callNumberId: string) =>
      `${baseURL}Batch/claims/${callNumberId}`,
  },
  auth: {
    login: `${secondaryUrl}login`,
  },
  callDialer: {
    connectCall: `${secondaryUrl}make-outbound-call`,
    agents: `${secondaryUrl}elevenlabs/agents`,
    fetchActiveCallStatus: `${webSocketURL}/`,
    fetchUserVoice: `${webSocketURL}/sst`,
    fetchAgentVoice: `${webSocketURL}/tts`,
    fetchUserAgentChat: `${secondaryUrl}conversations`,
    fetchCallLogs: `${secondaryUrl}call-logs`,
    hangupCall: `${secondaryUrl}hangup`,
    elevenLabsConversation: (conversationId: string) =>
      `${secondaryUrl}elevenlabs/conversations/${conversationId}`,
    deleteCallLogs: `${secondaryUrl}delete-call-logs`,
    convertXmlToBinary: `${secondaryUrl}api/xml-to-binary`,
  },
  batches: {
    agents: `${secondaryUrl}elevenlabs/agents`,
    elevenLabsRecording: (conversationId: string) =>
      `${secondaryUrl}elevenlabs/conversations/${conversationId}/audio`,
    fetchBatchCalls: `${baseURL}Batch/callnumbers`,
    fetchBatchList: `${baseURL}Batch/batches`,
    assignBatchToTeam: `${baseURL}Batch/assign-batch-team`,
    deleteBatch: `${baseURL}Batch/delete-batch`,
    createBatch: `${baseURL}Batch/create`,
    fetchBatchStatus: `${webSocketURL}/batch`,
    fetchCallStatus: `${webSocketURL}/`,
    runningBatches: `${webSocketURL}/runningbatch`,
    startBatchCalls: (batchId: string) =>
      `${secondaryUrl}batches/${batchId}/start`,
    stopBatchCalls: (batchId: string) =>
      `${secondaryUrl}batches/${batchId}/stop`,
    assignBatch: `${baseURL}Batch/assign-batch`,
    hangupCall: `${secondaryUrl}hangup`,
    fetchCallTranscription: `${webSocketURL}/transcript`,
    fetchBatchLogs: `${baseURL}Batch/batchlogs`,
    fetchBatchExecution: `${baseURL}Batch/batchexecutions`,
    fetchBatchExecutionDetails: `${baseURL}Batch/callNumberexecutions`,
    fetchBatchReports: `${baseURL}Batch/batchreport`,
    downloadBatchReportCsv: (batchId: string, batchExecutionId: string) =>
      `${baseURL}Batch/batchreport/${batchId}/${batchExecutionId}/download`,
    fetchBatchCallRecording: `${baseURL}recording`,
    fetchActiveBatchCallsList: `${baseURL}Batch/startcallnumbers`,
    fetchBatchCallInputFields: `${baseURL}Batch/getBatchInputFields`,
    fetchBatchCallInputAndOutputFields: `${baseURL}Batch/getBatchInputandOutputFields`,
  },
  clients: {
    createClient: `${baseURL}addclient`,
    updateClient: `${baseURL}updateclient`,
    fetchClientList: `${baseURL}getclients`,
    deleteClient: `${baseURL}deleteclient`,
    assignClient: `${baseURL}assignclient`,
    archiveUnarchiveClient: `${baseURL}archiveorunarchiveclient`,
    fetchClientsAssociatedWithUser: `${baseURL}getclientbyuser`,
  },
  teams: {
    fetchTeamsList: `${baseURL}teams/get-teams`,
    createTeam: `${baseURL}teams/create`,
    addUserCollectorToTeam: `${baseURL}teams/add-members`,
    enableDisableTeam: `${baseURL}teams/toggle-active`,
    updateTeam: `${baseURL}teams/update`,
    deleteTeam: `${baseURL}teams/delete`,
    fetchTeam: `${baseURL}teams`,
  },
  csv: {
    fetchCSVFields: `${secondaryUrl}schema/fields`,
    updateCSVFields: `${secondaryUrl}schema/save-synonyms`,
  },
  logs: {
    callLogs: `${baseURL}call-logs`,
  },
  dashboard: {
    fetchCardData: `${baseURL}Dashboard/callcounts`,
    fetchOutgoingChartData: `${baseURL}Dashboard/outboundcalls`,
    fetchConnectionRateChartData: `${baseURL}Dashboard/connectionrate`,
    fetchConcurrentCallsChartData: `${baseURL}Dashboard/concurrentcalls`,
    trackActiveCalls: `${webSocketURL}/activecalls`,
  },
  roles: {
    fetchRoleList: `${baseURL}getroles`,
    fetchFeaturesList: `${baseURL}features`,
    addRole: `${baseURL}addroles`,
    updateRole: `${baseURL}updaterole`,
    'archive&unarchive': `${baseURL}archiveorunarchiveroles`,
    addFeaturesToRole: `${baseURL}addfeaturestorole`,
    addClientsToRole: `${baseURL}addclientstorole`,
    fetchRoleById: `${baseURL}getrolebyid`,
    fetchFeaturesOfUser: `${baseURL}getfeaturesbyrole`,
  },
  features: {
    fetchFeatureList: `${baseURL}Features/features`,
    addFeature: `${baseURL}Features/addfeature`,
    updateFeature: `${baseURL}Features/updatefeature`,
  },
};
